module.exports = __webpack_public_path__ + "static/media/optibolt-logo.a635d99a.jpg";